import { ActionInfoModel } from '../action-info.model';
import { LockHistoryStateEnum } from '../enums';
import { RefProperty } from '../ref-property.model';

export class LockObjectHistoryPresenterModel {
  /**
   * The uuid of the lock.
   */
  id: string;
  /**
   * The id of the object that is locked. This is unique
   */
  lockedObject: RefProperty;
  /**
   * The action done by the user
   */
  action: LockHistoryStateEnum;
  /**
   * The id of the user that locked the object.
   */
  lockedBy?: RefProperty;
  unlockedBy?: RefProperty;
  /**
   * The date of the lock.
   */
  lockStartDate: string;
  /**
   * The date of the lock expiration.
   */
  lockEndDate: string;

  actionInfo: ActionInfoModel;
}
